<app-header></app-header>

<app-main-layout-sidebar></app-main-layout-sidebar>

<div>
  <router-outlet></router-outlet>
</div>
